import React, { useState } from "react";
import $ from "jquery";
import * as url from "../../../helpers/url_helper";
import { Images } from "../../../constants/images";
import { convertLocalDate } from "../../../Utils/configController";
import { ToastContainer, toast } from "react-toastify";
import Request from "../../../helpers/request";
import ConfirmationModal from "../../../components/Common/ConfirmationModal";
import FirmwareDataTableTest from "./FirmwareDataTableTest";

const FirmwareVersionListTest = ({
  setDataTableId: notifyParentDataTableId,
}: any) => {
  const [tableDomId, setTableDomId] = useState<string | null>(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteData, setDeleteData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: "Hardware",
      render: function (data: any, type: any, row: any) {
        return row?.name ? `${row?.name}(${row?.hardwareVersion})` : "-";
      },
    },
    {
      title: "Firmware Version",
      render: function (data: any, type: any, row: any) {
        return row?.firmwareVersion ? `${row?.firmwareVersion}` : "-";
      },
    },
    {
      title: "Type",
      render: function (data: any, type: any, row: any) {
        const typeBadge =
          row?.env === "qa"
            ? '<span class="font-size-11 badge-soft-danger badge bg-secondary">QA</span>'
            : '<span class="font-size-11  badge-soft-success badge bg-secondary">PROD</span>';

        return typeBadge;
      },
    },
    {
      title: "Is Stable?",
      render: function (data: any, type: any, row: any) {
        return row?.isStable ? "1" : "0";
      },
    },
    {
      title: "Uploaded Date",
      render: function (data: any, type: any, row: any) {
        return row?.createdAt ? convertLocalDate(row?.createdAt) : "-";
      },
    },
    {
      title: "Actions",
      render: function () {
        return `<div class="d-flex gap-2">
                                <button class="edit-btn" style="border: none; outline: none; background: none;">
                                <img src="${Images.DownloadIcon}" alt="Download" style="width: 20px; height: 20px;">
                                </button>
                                 <button class="copy-link" style="border: none; outline: none; background: none;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard" viewBox="0 0 16 16">
                                      <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z"/>
                                      <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z"/>
                                    </svg>
                                </button>
                                <button type="button" class="delete-btn" title="Delete" style="border: none; outline: none; background: none; color: #000000;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                      <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                                      <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                                    </svg>
                                </button>
                            </div>`;
      },
    },
  ];
  const handleDownloadClick = (rowData: any) => {
    const url = rowData.binFilePath.includes("http:")
      ? rowData.binFilePath.replace("http:", "https:")
      : rowData.binFilePath;

    const link = document.createElement("a");
    link.href = url;
    link.download = "filename.bin"; // Set the desired filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const reloadDataTable = () => {
    if (tableDomId) {
      const dataTableInstance: any = $(`#${tableDomId}`).DataTable();
      dataTableInstance.ajax.reload(null, false);
    }
  };

  const handleDeleteClick = (rowData: any) => {
    setDeleteData(rowData);
    setDeleteModalOpen(true);
  };

  const deleteFirmwareApiCall = () => {
    const firmwareId = deleteData?.id ?? deleteData?._id;
    if (!firmwareId) {
      toast.error("Missing firmware id.");
      return;
    }
    setLoading(true);
    Request.delete(url.DELETE_FIRMWARE, { id: firmwareId })
      .then((res) => {
        toast.success(res.data?.msg ?? "Firmware deleted successfully.");
        setDeleteModalOpen(false);
        setDeleteData(null);
        reloadDataTable();
      })
      .catch((err) => {
        const errorMsg =
          err?.response?.data?.msg ||
          err?.response?.data?.errors?.[0]?.msg ||
          "Failed to delete firmware.";
        toast.error(errorMsg);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleCopyLinkClick = (rowData: any) => {
    const url = rowData.binFilePath.includes("http:")
      ? rowData.binFilePath.replace("http:", "https:")
      : rowData.binFilePath;

    navigator.clipboard
      .writeText(url)
      .then(() => {
        toast.success("Copied!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);

        toast.success("Failed to copy");
      });
  };
  const handleDataTableIdChange = (id: any) => {
    setTableDomId(id);
    notifyParentDataTableId?.(id);
  };

  const deleteModalText = deleteData
    ? `Are you sure you want to delete firmware version "${
        deleteData?.firmwareVersion ?? deleteData?.id ?? ""
      }"?`
    : "";

  return (
    <>
      <ToastContainer />
      {isDeleteModalOpen && (
        <ConfirmationModal
          headerTitle="Delete firmware?"
          text={deleteModalText}
          buttonText="Delete"
          onClick={deleteFirmwareApiCall}
          cancleBtnClick={() => {
            setDeleteModalOpen(false);
            setDeleteData(null);
          }}
          loading={loading}
        />
      )}
      <FirmwareDataTableTest
        // data={areaList}
        apiURL={`${url.BASE_URL}${url.FIRMWARE_LIST}`}
        columns={columns}
        title={"Firmware Version List"}
        handleEditClick={handleDownloadClick}
        handleCopyLinkClick={handleCopyLinkClick}
        handleDeleteClick={handleDeleteClick}
        onDataTableRefresh={handleDataTableIdChange}
        idName={"FirmwareVesrionList"}
      />
    </>
  );
};

export default FirmwareVersionListTest;
